import { CheckIcon } from "@heroicons/react/outline";

import { CopyButton } from "@/components/ui/copy-button";
import { Input } from "@/components/ui/input";

interface ApiKeyCopyRowProps {
  apiKey: string;
}

export const ApiKeyCopyRow = ({ apiKey }: ApiKeyCopyRowProps) => (
  <div className="flex items-center gap-2 rounded-xl border border-gray-200 bg-white px-3 py-2">
    <CheckIcon className="h-5 w-5 shrink-0 text-green-600" />
    <Input
      value={apiKey}
      readOnly
      className="border-0 bg-transparent px-0 text-sm text-gray-700 shadow-none focus-visible:ring-0"
    />
    <CopyButton text={apiKey} iconSize="h-4 w-4" />
  </div>
);
